var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHzMusic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 54.75V62H15v-7.25A7.05 7.05 0 0122.25 48h31.5A7 7 0 0161 54.75zM48 28.57a10 10 0 10-20 0 10 10 0 0020 0zm-23 8.61V24a10.83 10.83 0 013.81-8.11A13.92 13.92 0 0138 12.53h.67C45.53 12.85 51 17.87 51 24v11.92A5.85 5.85 0 0145 42h-9v3h10a8.8 8.8 0 008-8.31 7.4 7.4 0 000-14c-.74-7.12-7.2-12.76-15.18-13.09h-.75c-8.31 0-15.16 5.76-15.92 13.11a7.4 7.4 0 00-5.08 7c-.07 4.1 3.29 7.47 7.93 7.47z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/HZ_music.7bc1470c.svg";
export { SvgHzMusic as ReactComponent };